import { type AxiosError, isAxiosError } from 'axios';
import { message } from 'ui';

export const handleAxiosError = <T = unknown>(error?: AxiosError<T> | Error | null, customMessage?: string) => {
  if (error) {
    if (isAxiosError(error)) {
      if (!error.response && !window.navigator.onLine) {
        message.error('Please check your internet connection.');
        return;
      }

      if (error.response) {
        switch (error.response.status) {
          case 403:
            message.error('Sorry, you are not authorized to perform this action.');
            return;
          case 404:
            message.error('Sorry, resource or target does not exist.');
            return;
        }
      }
    }

    message.error(customMessage ?? 'Sorry, something went wrong.');
  }
};
